import React, { useState } from 'react';
import { isAxiosError } from 'axios';
import { FormComponent, UiComponent } from 'components';
import { MeQuery } from 'queries';
import useModal from 'hooks/useModal';
import { toast } from 'react-toastify';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';

// 내 비밀번호 변경
function ChangePassword() {
  const { handleClose, handleAlert } = useModal();
  const { mutateAsync: change, isPending } = MeQuery.useChangePassword();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');

  const handleSubmit = async () => {
    if (!currentPassword || !newPassword) {
      handleAlert('비밀번호를 입력해주세요');
      return;
    }
    if (newPassword.length < 8) {
      handleAlert('새 비밀번호는 8자 이상 입력해주세요');
      return;
    }
    if (newPassword !== confirm) {
      handleAlert('새 비밀번호가 일치하지 않습니다');
      return;
    }
    try {
      await change({ currentPassword, newPassword });
      toast.success('비밀번호가 변경되었습니다');
      handleClose();
    } catch (error) {
      const message = isAxiosError<{ message?: unknown }>(error)
        ? error.response?.data?.message
        : undefined;
      toast.error(
        typeof message === 'string' ? message : DEFAULT_ERROR_MESSAGE,
      );
    }
  };

  return (
    <div css={{ width: 360, '> p': { margin: '16px 0 8px', fontWeight: 600 } }}>
      <p>현재 비밀번호</p>
      <FormComponent.Input
        type="password"
        value={currentPassword}
        onChange={(e) => setCurrentPassword(e.target.value)}
        css={{ width: '100%' }}
      />
      <p>새 비밀번호</p>
      <FormComponent.Input
        type="password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        placeholder="8자 이상"
        css={{ width: '100%' }}
      />
      <p>새 비밀번호 확인</p>
      <FormComponent.Input
        type="password"
        value={confirm}
        onChange={(e) => setConfirm(e.target.value)}
        css={{ width: '100%' }}
      />
      <div css={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
        <UiComponent.Button
          type="button"
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={isPending}
        >
          변경하기
        </UiComponent.Button>
      </div>
    </div>
  );
}

export default ChangePassword;
